import { TimeTradingEnum } from './types';

export const SalariedDirectorFieldsQuestions = {
  timeTrading: {
    titleKey: 'affordabilityCalculator.salariedDirector.timeTrading.title',
    textKey: 'affordabilityCalculator.salariedDirector.timeTrading.text',
    options: [
      {
        labelKey: 'affordabilityCalculator.salariedDirector.timeTrading.lessTime',
        value: TimeTradingEnum.lessThanTwoYears,
      },
      {
        labelKey: 'affordabilityCalculator.salariedDirector.timeTrading.moreTime',
        value: TimeTradingEnum.moreThanTwoYears,
      },
    ],
  },
  basicAnnualSalaryRecentYear: {
    titleKey: 'affordabilityCalculator.salariedDirector.basicAnnualSalaryRecentYear.title',
    textKey: 'affordabilityCalculator.salariedDirector.basicAnnualSalaryRecentYear.text',
  },
  dividendsRecentYear: {
    titleKey: 'affordabilityCalculator.salariedDirector.dividendsRecentYear.title',
  },
  basicAnnualSalaryPreviousYear: {
    titleKey: 'affordabilityCalculator.salariedDirector.basicAnnualSalaryPreviousYear.title',
    textKey: 'affordabilityCalculator.salariedDirector.basicAnnualSalaryPreviousYear.text',
  },
  dividendsPreviousYear: {
    titleKey: 'affordabilityCalculator.salariedDirector.dividendsPreviousYear.title',
  },
  error: {
    required: 'common.error.requiredField',
  },
};
